module.exports = __webpack_public_path__ + "static/media/search-mobile.d12a92ad.svg";